<template>
  <div class="module-wrapper">
    <div class="module-header animated fadeInDown">
      <h2>Workers</h2>
      <button @click="addWorker" class="btn btn-gradient">
        <i class="fas fa-plus"></i> Add Worker
      </button>
    </div>

    <div v-if="loading" class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-2x"></i> Loading Workers...
    </div>

    <div v-else>
      <table v-if="workers.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Assigned Unit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="worker in workers" :key="worker.id">
            <td>{{ worker.name }}</td>
            <td>{{ worker.role }}</td>
            <td>{{ worker.unitName }}</td>
            <td>
              <button @click="editWorker(worker)" class="btn btn-sm btn-primary">Edit</button>
              <button @click="deleteWorker(worker.id)" class="btn btn-sm btn-danger">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No workers found. Add one to get started.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'WorkersComponent',
  computed: {
    ...mapState('workers', ['workers', 'loading']),
  },
  methods: {
    addWorker() { this.$router.push({ name: 'AddWorker' }); },
    editWorker(worker) { console.log('Edit', worker); },
    deleteWorker(id) { if(confirm('Delete this worker?')) this.$store.dispatch('workers/deleteWorker', id); },
  },
  mounted() { this.$store.dispatch('workers/fetchWorkers'); },
};
</script>

<style scoped>
@import "@/assets/gradient.css"; /* optional gradient utility file */
.module-wrapper { padding:20px; background:#f4f6f9; border-radius:12px; }
.module-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; }
.btn-gradient { background: linear-gradient(135deg,#6a11cb,#2575fc); color:#fff; border:none; padding:8px 15px; border-radius:6px; transition: all 0.3s; }
.btn-gradient:hover { transform: scale(1.05); }
.spinner-container { display:flex; justify-content:center; align-items:center; height:100px; font-size:1.2rem; color:#555; }
.badge { padding:4px 8px; border-radius:5px; color:#fff; }
</style>
